import PropTypes from 'prop-types';
import { Swiper, SwiperSlide } from "swiper/react";
// import Swiper core and required modules
import SwiperCore, {
    FreeMode, Scrollbar, Mousewheel
} from 'swiper';

// install Swiper modules
import { WeatherI } from '../../core/interfaces/Weather';


SwiperCore.use([FreeMode, Scrollbar, Mousewheel]);

export const BoxWeather = ({ data, background, textcolor }) => {

    const weather: WeatherI = data;
    const currentHour: number = new Date().getHours();

    const getHours = (time: any) => {
        let hour = new Date(time).getHours()
        return (hour > 12 ? (hour - 12) : (hour === 0 ? 12 : hour)) + (hour < 12 ? 'AM' : 'PM');
    }

    const validateHour = (time: any) => {
        return (new Date(time).getHours()) > currentHour;
    }

    return (
        <div className="rounded-lg w-full h-auto bg-weather text-white p-4 mt-2" style={{ backgroundColor: background, color: textcolor }}>

            <div className="flex w-full justify-between items-center">
                <div className="flex flex-col justify-start items-start">
                    <span>{weather.location.name}</span>
                    <span style={{ 'fontSize': '44px', 'lineHeight': '30px' }}>{weather.current.temp_c}°</span>
                </div>

                <div className="flex flex-col justify-end items-end">
                    <img src={weather?.current?.condition?.icon} alt="" width={'26px'} height={'26px'} />
                    <span>{weather.current.condition.text}</span>
                    <span>H:{weather.forecast.forecastday[0].day.maxtemp_c}° L:{weather.forecast.forecastday[0].day.mintemp_c}°</span>
                </div>
            </div>

            <Swiper direction={'horizontal'} slidesPerView={'auto'} freeMode={true} scrollbar={false} mousewheel={true} className="mySwiper2" passiveListeners={true}>
                {
                    weather.forecast.forecastday[0].hour.map((hour, i) => {

                        if (validateHour(hour.time)) {
                            return (
                                <SwiperSlide key={'whour_' + (i + 1)} className='mr-4 swipweather'>
                                    <div className="flex flex-col items-center">
                                        <span>{getHours(hour.time)}</span>
                                        <img src={hour.condition.icon} alt="" width={'26px'} height={'26px'} />
                                        <span>{hour.temp_c}°</span>
                                    </div>
                                </SwiperSlide>
                            );
                        } else {
                            return ('')
                        }

                    })
                }


            </Swiper>
        </div>
    )
}



BoxWeather.propTypes = {
    data: PropTypes.object,
    background: PropTypes.string,
    textcolor: PropTypes.string
};